import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppNotificationInterface } from '../models/app-notification.interface';
import * as CoreStoreActions from '../store/core-store.actions';
import * as CoreStoreSelectors from '../store/core-store.selectors';

@Injectable({ providedIn: 'root' })
export class AppNotificationsService {
  private readonly _store = inject(Store);

  autoDismissDefaultDuration: number = 5000;

  getNotifications$(): Observable<Array<AppNotificationInterface>> {
    return new Observable((observer: any) => {
      const subscription = this._store
        .select(CoreStoreSelectors.selectAppNotifications)
        .subscribe((notifications: Array<AppNotificationInterface>) => {
          observer.next(notifications);
        });

      return () => subscription.unsubscribe();
    });
  }

  pushNotification(notification: AppNotificationInterface) {
    return this._store.dispatch(
      CoreStoreActions.pushAppNotification({ notification }),
    );
  }

  dismissNotification(id: string) {
    return this._store.dispatch(
      CoreStoreActions.dismissAppNotification({ id }),
    );
  }

  dismissNotificationsWithTopic(topic: string) {
    return this._store.dispatch(
      CoreStoreActions.dismissAppNotificationsWithTopic({ topic }),
    );
  }

  dismissNotificationsWithTopics(topics: Array<string>): void {
    for (const topic of topics) {
      this.dismissNotificationsWithTopic(topic);
    }
  }
}
